import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RequestTypes } from '../models/request-types.enum';
import { HttpService } from '../services/http.service';

import { Country } from '../models/country-model';
import {HttpConfiguration} from '../configs/app.http.config';

import { CountryStatesParams } from '../models/countryStatesParams';
import { CountryParams } from '../models/countryParams';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CountryHttpService extends HttpService {
    constructor(
        httpConfig: HttpConfiguration,
        http: HttpClient) {
        super('api/country/', RequestTypes.InternalApi, httpConfig, http);
    }

    public getCountries(countryParams: CountryParams): Observable<Country[]> {
        return this.get(`getCountries?forLegacy=${countryParams.forLegacy}&addressType=${countryParams.addressType}`,
            null).pipe();
    }

    public getStates(countryStatesParams: CountryStatesParams): Observable<any> {
        return this.get(`getStates?forLegacy=${countryStatesParams.forLegacy}&addressType=${countryStatesParams.addressType}&countryId=${countryStatesParams.countryId}`,
            null).pipe();
    }
}




// WEBPACK FOOTER //
// ./src/custom_modules/autocomplete/services/country.http.service.ts